import React from 'react';
import {IconAlertCircle, IconLock, IconUserShield} from '@tabler/icons-react';
import {FallbackType} from "@/features/auth/domain/auth.types.ts";

interface FallbackIconProps {
    type: FallbackType;
    customIcon?: React.ReactNode;
}

export function FallbackIcon({type, customIcon}: FallbackIconProps): React.ReactNode {
    if (customIcon) return customIcon;

    switch (type) {
        case FallbackType.Button:
            return <IconLock size={18}/>;
        case FallbackType.Section:
        case FallbackType.Page:
            return <IconUserShield size={64} strokeWidth={1.5}/>;
        default:
            return <IconAlertCircle size={16}/>;
    }
}